// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uF3k","colBig":"styles_colBig__1sVF1","colSmall":"styles_colSmall__28r9_"};